import { formatUnits } from "viem";

interface ReceiveSource {
  originTokenSymbol?: string | null;
  reportedInputAmount?: string | null;
}

/** Rows written before source-currency support were always USDC. */
export function receiveTokenSymbol(source: ReceiveSource): string {
  return source.originTokenSymbol ?? "USDC";
}

/** Match the backend projection split, including legacy rows without a source symbol. */
export function receiveAddressEntity(source: ReceiveSource) {
  return receiveTokenSymbol(source) === "USDC" ? "depositAddress" : "stablecoinReceiveAddress";
}

/** All supported receive assets use six decimals. Preserve exact integer precision. */
export function formatReceiveAmount(source: ReceiveSource): string {
  const amount = source.reportedInputAmount;
  if (amount == null || !/^\d+$/.test(amount)) return "—";
  const symbol = receiveTokenSymbol(source);
  if (!["USDC", "USDT", "USDT0"].includes(symbol)) return `${amount} base units (${symbol})`;
  return `${formatUnits(BigInt(amount), 6)} ${symbol}`;
}
